import { useContext, useEffect } from "react";
import { SocketContext } from "@/context/Socket";

export const useSockets = () => useContext(SocketContext);

export const useSocketReceiver = (eventName, eventCallback) => {
  const { socket } = useSockets();

  useEffect(() => {
    socket && socket.on(eventName, eventCallback);

    return () => socket && socket.off(eventName);
  }, [socket]);
};

export const useSocketEmitter = () => {
  const { socket } = useSockets();
  const emitter = (eventName, eventValue, eventCallback) =>
    socket && socket.emit(eventName, eventValue, eventCallback);

  return { emitter };
};
